<template>
  <div class="content">
    <div v-if="showLink || type === 'link'">
      <div class="description">
        {{ $t('kuai-lai-he-wo-yi-qi-lai-you-yan-jin-hang-aigc-3d-shi-pin') }}
      </div>
      <div class="link-container">
        <div class="label">
          {{ $t('xian-zai-dian-ji-lian-jie-huan-you-la-xin-hao-li-xiang-song') }}
        </div>
        <div class="link-content">
          <a-popover>
            <template #content>
              <span class="max-w-[268px]">{{ link }}</span>
            </template>
            <div class="link cursor-pointer">{{ link }}</div>
          </a-popover>
          <a-button type="primary" ghost @click="handleCopy">
            {{ $t('fu-zhi-lian-jie') }}
            <iconpark-icon name="link" size="14" class="ml-[4px] align-middle"></iconpark-icon>
          </a-button>
        </div>
      </div>
    </div>
    <div v-else class="tip">
      <div v-if="type === 'login'">
        <div>
          {{
            $t(
              'nin-yi-zhu-ce-cheng-gong-xin-yong-hu-zhu-ce-yi-wei-nin-zi-dong-fa-fang-xx-yan-bi-kuai-lai-kai-shi-ni-de-3d-shi-pin-chuang-zuo-zhi-lv-ba',
            )
          }}
          <div>
            <div>{{ $t('ti-yan-yan-bi') }}{{ coin }}</div>
            <div>
              {{ $t('cheng-gong-jie-suo-you-yan-liang-dian-gong-neng-0') }}
              <div>
                {{
                  $t(
                    'hai-liang-3d-jiao-se-gao-zhi-liang-chao-xie-shi-3d-xu-ni-ren-jiao-se-yi-zhan-jin-xuan',
                  )
                }}
              </div>
              <div>
                {{
                  $t(
                    'aigc-nei-rong-sheng-cheng-jiao-se-xing-xiang-dong-hua-sheng-yin-deng-guang-yun-jing-ai-sheng-cheng-nei-rong',
                  )
                }}
              </div>
              <div>
                {{
                  $t(
                    'yi-zhan-shi-chuang-zuo-jian-dan-yi-yong-kuai-su-shang-shou-ling-ji-chu-chuang-zuo-gao-zhi-liang-shi-pin',
                  )
                }}
              </div>
            </div>
          </div>
        </div>
        <!-- <div v-if="type === 'loginInvite'">

      </div> -->
      </div>
      <div v-if="type === 'register'">
        <div>
          {{ $t('zhu-ce-cheng-gong') }}，{{ $t('li-ji') }}
          <a class="url" @click="handleSubscribe">{{ $t('qu-sheng-ji') }}</a>
          ，{{ $t('jie-suo-geng-duo-la-xin-jiang-li') }}
        </div>
        <div>
          {{ $t('huo-zhe-sheng-cheng-ni-zi-ji-de') }}
          <a class="url" @click="handleShowLink">
            {{ $t('zhuan-shu-yao-qing-lian-jie') }}
          </a>
          ，{{ $t('yao-qing-hao-you-yi-qi-ling-qu-quan-yi-ba') }}
        </div>
      </div>
      <div v-if="type === 'buy'">
        <div>
          {{ $t('nin-zhi-qian-de-yao-qing-zhu-li-ren-wu-shang-wei-wan-cheng') }}，{{ $t('li-ji') }}
          <a class="url" @click="handleSubscribe">{{ $t('qu-sheng-ji') }}</a>
          {{ $t('wan-cheng-yao-qing-zhu-li-ren-wu') }}
        </div>
        <div>
          {{ $t('huo-zhe-sheng-cheng-ni-zi-ji-de') }}
          <a class="url" @click="handleShowLink">{{ $t('zhuan-shu-yao-qing-lian-jie') }}</a>
          {{ $t('yao-qing-hao-you-yi-qi-ling-qu-quan-yi-ba') }}
        </div>
      </div>
      <div v-if="type === 'registerAward'">
        {{ $t('zhu-ce-cheng-gong-quan-yi-yi-dao-zhang') }}{{ $t('li-ji') }}
        <a class="url" @click="handleSubscribe">{{ $t('qu-sheng-ji') }}</a>
        ，{{ $t('jie-suo-geng-duo-la-xin-jiang-li') }}
        <div>
          {{ $t('huo-zhe-sheng-cheng-ni-zi-ji-de') }}
          <a class="url" @click="handleShowLink">
            {{ $t('zhuan-shu-yao-qing-lian-jie') }}
          </a>
          ，{{ $t('yao-qing-hao-you-yi-qi-ling-qu-quan-yi-ba') }}
        </div>
      </div>
    </div>
    <div class="footer">
      <a-button
        v-if="showLink || type === 'login' || type === 'link'"
        size="large"
        type="primary"
        @click="closeModal"
      >
        {{ $t('zhi-dao-le') }}
      </a-button>
      <div v-else class="flex flex-nowrap gap-x-[20px]">
        <a-button size="large" type="primary" ghost @click="closeModal">
          {{ $t('qu-xiao') }}
        </a-button>
        <a-button size="large" type="primary" @click="handleSubscribe">
          {{ $t('qu-sheng-ji') }}
        </a-button>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { getI18nService } from '@rendora/common/services/i18n';
import { getPullNewLink, readRecordType } from '~/api';
import { INVITE_RECORD_TYPE, type InviteInfoItem } from '~/api/interface/marketing';
import { PageKey } from '~/constants/page';
import { copyToClipboard } from '~/utils';

type Modal_TYPE = 'link' | 'register' | 'registerAward' | 'buy' | 'login' | 'loginInvite';

interface ContentProps {
  type?: Modal_TYPE; // 分享 | 注册成功| 购买套餐
  list?: InviteInfoItem[]; // 拉新记录列表
  code?: string; // 邀请码
  cancel: () => void;
  coin?: number;
}

const props = defineProps<ContentProps>();
const { t: $t } = getI18nService();
// const emits = defineEmits(['cancel'])
const router = useRouter();
const showLink = ref(false);
// const open = ref(false)
// const modalType = ref<Modal_TYPE>()
const inviteCode = ref();

// const title = computed(() =>
//   showLink.value || modalType.value === 'link'
//     ? '你的专属邀请链接已生成'
//     : modalType.value === 'register' || modalType.value === 'registerAward'
//     ? '注册完成'
//     : '助力任务尚未完成'
// )

const link = computed(() => {
  return `${location.origin}/pull-new?code=${props.code || inviteCode.value}`;
});

const handleShowLink = async () => {
  if (!props.code) {
    await handleGetLink();
  }

  showLink.value = !showLink.value;
};

const closeModal = async () => {
  if (props.type === 'register' || props.type === 'registerAward') {
    const item = props.list?.find(o => o.goon_behavior_type === INVITE_RECORD_TYPE.REGISTER);
    if (item && !item.accept_read) {
      await readRecordType(0, { record_id: item.id });
    }
  }
  props.cancel?.();
};

const handleCopy = () => {
  // 保存当前滚动位置
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

  try {
    copyToClipboard(
      $t(
        'kuai-lai-he-wo-yi-qi-lai-you-yan-jin-hang-aigc-3d-shi-pin-chuang-zuo-ba-xian-zai-dian-ji-lian-jie-jin-hang-zhu-ce-yao-qing-shuang-fang-du-you-la-xin-hao-li-xiang-song-linkvalue',
      ) + link.value,
    );
    message.success($t('fu-zhi-cheng-gong'));

    // 立即恢复滚动位置
    window.scrollTo(scrollLeft, scrollTop);
  } catch (error) {
    console.error(error);
    message.error($t('wen-ben-fu-zhi-shi-bai'));

    // 立即恢复滚动位置
    window.scrollTo(scrollLeft, scrollTop);
  }
};

const handleSubscribe = () => {
  closeModal();
  router.push({
    name: PageKey.SUBSCRIBE,
  });
};

// 获取邀请码信息
const handleGetLink = async () => {
  try {
    const res: any = await getPullNewLink();
    if (res?.code === 0 && res.data.code) {
      inviteCode.value = res.data.code;
    }
  } catch (error) {
    console.error(error);
  }
};

onMounted(() => {
  if (props.type === 'link') {
    showLink.value = true;
    if (!props.code) {
      handleGetLink();
    }
  }
});
</script>
<style lang="scss" scoped>
.content {
  @apply flex flex-col justify-between px-[42px] pt-[30px] pb-[16px] font-medium h-[235px];

  .description {
    @apply text-14 text-font-1 mb-[16px] font-medium;
  }

  .link-container {
    @apply p-[16px] bg-back-3 rounded-[6px];

    .label {
      @apply text-12 text-font-70 mb-[10px];
    }

    .link-content {
      @apply flex flex-nowrap items-center gap-x-[10px];
    }

    .link {
      @apply p-[10px_6px] bg-back-1 rounded-[6px] text-14 text-font-80 truncate;
    }
  }

  .tip {
    @apply text-14 text-font-70 font-medium;
  }
  .url {
    @apply text-primary cursor-pointer;
  }
}

.footer {
  @apply w-full h-auto py-[16px] flex justify-center items-center text-center;
  border-top: 1px solid var(--back-4);
  // border-bottom: none;

  :deep(.ant-btn) {
    min-width: 90px;
  }
}
</style>

<style lang="scss">
.yy-invite-modal {
  .ant-modal-close {
    top: 11px;
  }
  .ant-modal-close-x {
    font-size: 14px;
  }
  .ant-modal-header {
    @apply p-[12px_16px] font-medium text-font-1;

    border-bottom: 1px solid var(--back-4);
  }
  .ant-modal-content {
    padding: 0 !important;
  }
  .ant-modal-title {
    line-height: 22px !important;
    text-align: center;
    font-weight: 500 !important;
  }
}
</style>
